
.sn-call-to-action-type-7 {
    &__container {
        @include container;

        // The `container` mixin caps at $media-desktop (1440); match the signnow
        // me-container width instead to line up with the rest of the page.
        max-width: $sn-container-max-width;
        padding-top: 0;
        padding-bottom: $spacing-5xl;

        @include desktop {
            padding-top: 0;
            padding-bottom: $spacing-6xl;
        }

        @include desktop-lg {
            padding-bottom: $spacing-7xl;
        }
    }

    &__inner {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: var(--spacing-xl);
        background-color: $background-color-brand-primary-darkest;
        border-radius: map-get($border-radii, lg);
        padding: var(--spacing-3xl) var(--spacing-xl);
        color: $color-neutral-white;

        @include desktop {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: var(--spacing-3xl) var(--spacing-5xl);
        }
    }

    &__content {
        flex: 1;

        .me-heading {
            display: block;
            font-size: map-get($font-sizes, 3xl);
            font-weight: map-get($font-weights, bold);
            line-height: map-get($line-heights, xl);
            margin: 0 0 var(--spacing-md);

            @include desktop {
                font-size: map-get($font-sizes, 5xl);
            }
        }

        .me-text {
            display: block;
            font-size: map-get($font-sizes, md);
            line-height: map-get($line-heights, lg);
            margin: 0;
            color: $color-neutral-white;

            @include desktop {
                font-size: map-get($font-sizes, lg);
            }
        }
    }

    &__action {
        flex-shrink: 0;
        display: inline-flex;

        .me-button {
            min-width: 208px;

            // CTA button: 208×48. The height comes from the padding — 24px line-height
            // + 2×2px border + 2×10px padding. The theme rule
            // `body.signnow [data-color-mode] .me-button--primary` is (0,3,1) and outranks the
            // three classes here, so the `[data-color-mode]` ancestor is matched too — (0,4,0).
            [data-color-mode] &.me-button--primary {
                padding: 0.625rem 1.2rem;
            }
        }
    }
}
